import CommonLayout from 'layouts/DashboardLayout'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Badge, Box, Dialog, DialogContent, DialogTitle, Grid, IconButton, Paper, Slide, Stack, Tooltip, Typography } from '@mui/material'
import { AgGridTable } from 'components/tables/AgGridTable'
import { useNavigate } from 'react-router-dom'
import { formatDate } from 'utilities/common'
import Search from 'examples/Search'
import { useDebounce } from 'hooks/useDebounce'
import StatusText from 'common/component/StatusText'
import StaticsOverview from 'common/StaticsOverview'
import InActiveIcon from 'common/customIcons/inactive'
import ActiveIcon from 'common/customIcons/active'
import { addSpaceBeforeCapital } from 'utilities/common'
import { formatUsPhoneNumber } from 'utilities/common'
import MembersIcon from 'common/customIcons/members'
import CloseIcon from '@mui/icons-material/Close';
import { grey } from '@mui/material/colors'
import Zoom from 'react-medium-image-zoom'
import { formatTimestampTo12HourTime } from 'utilities/common'
import { getImageExtension } from 'utilities/common'
import { getHyperwolfMembers } from '../../../redux/slices/hyperwolf/members'
import EditIcon from 'common/customIcons/edit'
import DeleteIcon from 'common/customIcons/delete'
import MDButton from 'components/MDButton';
import { RemoveRedEyeRounded } from '@mui/icons-material';
import { formatTimestampToDate } from 'utilities/common'
import { getPermissionsByMode } from 'utilities/common'
import { getData } from 'utilities/common'
import { hasSectionPermission } from 'utilities/common'

const uploadThumbnailImage = {
  borderRadius: "20px",
  width: "100px",
  height: "100px",
  objectFit: "cover",
  boxShadow: "0 0 1px rgb(0 0 0 / 20%)",
  marginRight: '10px'
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});
export default function HyperwolfMembers() {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const pageRef = useRef(0)
  const searchTermRef = useRef("")
  const mainGridApiRef = useRef('')
  const gridRefApi = useRef(null)
  const [searchTerm, setSearchTerm] = useState("")
  const [notesData, setNotesData] = useState("")

  const handleSearch = useDebounce((term) => {
    // Perform search operation with the debounced term
    pageRef.current = 0
    searchFn()
  }, 500);

  const { members = {}, loading = false } = useSelector(state => state.hyperwolfMemberSlice)

  const { activeMembersCount = 0, inactiveMembersCount = 0, total = 0 } = members || {}

  let localUser = getData('login-user-info')
  if (localUser) {
    localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Members", "Create");
  const canEdit = hasSectionPermission(permissionsForMode, "Members", "Edit/Update");
  const canView = hasSectionPermission(permissionsForMode, "Members", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Members", "Delete");

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: 'Full Name',
      field: 'firstName',
      key: "fullName",
      suppressMenu: false,
      cellRenderer: (props) => {
        return <Typography variant="caption" display="block" fontWeight="regular" sx={{ cursor: "pointer", whiteSpace: "normal", textTransform: 'capitalize' }}>{props?.data?.firstName}</Typography>
      },
      minWidth: 240,
    },
    {
      headerName: 'Email',
      field: 'email',
      suppressMenu: false,
      minWidth: 340,
    },
    {
      headerName: 'Phone',
      field: 'primaryPhone',
      suppressMenu: false,
      minWidth: 130,
      cellRenderer: (props) => {
        return props?.value ? formatUsPhoneNumber(props?.value) : "-"
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      suppressMenu: false,
      cellRenderer: (props) => {
        return <StatusText status={props?.data?.status} />
      },
      minWidth: 100
    },
    {
      headerName: 'Notes',
      field: 'notes',
      suppressMenu: false,

      // autoHeight: true,
      cellRenderer: (props) => {
        return ((props?.data?.blockOnlinePayments?.status)) ? <MDButton onClick={() => {
          setNotesData(props?.data);
        }} size="small" startIcon={<RemoveRedEyeRounded fontSize='small' />} variant="contained" color="primary" className="btn-primary-light">
          View Notes
        </MDButton> : '-';
      },
      minWidth: 140,
    },
    {
      headerName: 'Member Type',
      field: 'consumerType',
      suppressMenu: false,
      minWidth: 120,
      cellRenderer: (props) => {
        return props?.value ? addSpaceBeforeCapital(props?.value) : "-"
      },
      minWidth: 120
    },

    {
      headerName: 'Joined Date',
      field: 'joinedDate',
      suppressMenu: false,
      minWidth: 150,
      cellStyle: { textAlign: 'right', justifyContent: 'end' },
      headerClass: 'right-aligned-cell-header',
    },
    // {
    //   headerName: 'Actions',
    //   cellRenderer: (props) => {
    //     return <Box display="inline-flex" alignItems="center">
    //       <IconButton onClick={(e) => {
    //         e.stopPropagation();
    //         onEditClicked(props);
    //       }} color='primary' size='small' variant="primary">
    //         <EditIcon width='16px' height='16px' />
    //       </IconButton>
    //       <IconButton onClick={(e) => {
    //         e.stopPropagation();
    //         dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: props.data?.memberId, deleteType: 'member' }, modal: 'DELETE_MODAL' }));
    //       }} color='error' size='small' variant="primary" sx={{ marginLeft: 1 }}>
    //         <DeleteIcon width='16px' height='16px' />
    //       </IconButton>
    //     </Box>;
    //   },
    //   cellStyle: { textAlign: 'right', justifyContent: 'end' },
    //   headerClass: 'right-aligned-cell-header',
    //   minWidth: 120,
    //   maxWidth: 100,
    //   pinned: 'right'
    // },
  ]);

  function getSortInfo(data) {
    const sortInfo = {
      sortBy: 'memberGroup',
      sortByDirection: 'asc'
    };
    data.forEach(item => {
      if (item?.colId) {
        sortInfo.sortBy = item.colId;
        sortInfo.sortByDirection = item.sort === "asc" ? 'asc' : 'desc';

        // Handle specific case for consumerType
        if (item?.colId === 'consumerType') {
          // You can adjust this based on what you want to send to the API
          sortInfo.sortBy = item.sort === "asc" ? 'memberGroup' : "memberGroup";
        }
        if (item?.colId === 'joinedDate') {
          // You can adjust this based on what you want to send to the API
          sortInfo.sortBy = item.sort === "asc" ? 'startDate' : "startDate";
        }
      }
    });

    return sortInfo;
  }

  const getRows = async (params) => {
    gridRefApi.current = params;
    let filter = {}
    if (params?.sortModel.length) {
      filter = { ...getSortInfo(params?.sortModel) }
    }
    const encodedUnit = encodeURIComponent(encodeURIComponent(searchTermRef.current));

    dispatch(getHyperwolfMembers({ start: pageRef.current, limit: 20, term: searchTermRef.current, ...filter })).unwrap().then(res => {
      const { values, total } = res
      const membersArray = values?.map((item => {
        const date = item?.created ? new Date(item?.created) : ""
        return { ...item, status: item?.status ? "Active" : "Inactive", joinedDate: item.created ? formatDate(date) : "-", address: `${item?.deliveryAddress?.address} ${item?.deliveryAddress?.city} ${item?.deliveryAddress?.state} ${item?.deliveryAddress?.zipcode}` }
      }))
      params.successCallback([...membersArray], total);
      pageRef.current = pageRef.current + 20
    }).catch(() => {
      params.successCallback([], 0);
      pageRef.current = 0
    });
  }

  const searchFn = () => {
    const dataSource = {
      getRows
    }
    mainGridApiRef.current.ensureIndexVisible(0, null);
    mainGridApiRef.current.setGridOption('datasource', dataSource);
  }

  const onEditClicked = (row) => {
    navigate(`/hyperwolf/members/${row?.data?.email}`);
  };


  const onRowClicked = (row) => {
    if (row?.colDef?.headerName !== 'Actions' && row?.colDef?.headerName !== 'Notes') {
      navigate(`/hyperwolf/members/detail/${row?.data.email}`)
    }
  }

  const searchHandler = (event) => {
    const { value } = event.target;
    setSearchTerm(value);
    searchTermRef.current = value
    handleSearch(value);
  };

  useEffect(() => {
    if (mainGridApiRef?.current) {
      if (loading) {
        mainGridApiRef.current.showLoadingOverlay()
      } else if (members?.total === 0) {
        mainGridApiRef.current.showNoRowsOverlay()
      }
      else {
        mainGridApiRef.current.hideOverlay()
      }
    }

  }, [members, loading])

  return (
    <CommonLayout>
      {
        canView &&
        <>
          <Box p={{ xs: 2, sm: 3, lg: 4 }}>
            <Paper elevation={0} style={{ borderRadius: "12px" }}>
              <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="start" justifyContent="space-between" bgcolor="white" p={{ xs: 1, md: 2 }}>
                <StaticsOverview
                  color="warning"
                  iconShadow="iconShadowWarning"
                  icon={<MembersIcon />}
                  title="Total Members"
                  count={total}
                />
                <StaticsOverview
                  color="success"
                  iconShadow="iconShadowSuccess"
                  icon={<ActiveIcon />}
                  title="Active Members"
                  count={activeMembersCount}
                />
                <StaticsOverview
                  color="error"
                  iconShadow="iconShadowDanger"
                  icon={<InActiveIcon />}
                  title="Inactive Members"
                  count={inactiveMembersCount}
                />
              </Stack>
            </Paper>

            <Grid container alignItems="center" rowSpacing={2} columnSpacing={2} mt={1} mb={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant='h4'>Members</Typography>
              </Grid>

              <Grid item xs={12} sm={8}>
                <Stack direction="row" justifyContent={{ xs: "start", sm: "end" }} flexWrap="wrap" alignItems="stretch" gap={2}>
                  <Search placeholder="Search" label="" value={searchTerm} onChange={searchHandler} />
                </Stack>
              </Grid>
            </Grid>

            <AgGridTable maxLimit={20} col={columnDefs} getRows={getRows} mainGridApiRef={mainGridApiRef} pageRef={pageRef} isLoading={loading} onRowClicked={onRowClicked} style={{ height: "58vh" }} />
          </Box>

          <Dialog open={Boolean(notesData)} TransitionComponent={Transition} keepMounted maxWidth='xs' fullWidth className="notes-modal"
            onClose={() => setNotesData('')}
            aria-describedby="alert-dialog-slide-description"
          >

            <DialogTitle id="draggable-dialog-title" display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
              Card Blocked
              <IconButton onClick={() => setNotesData('')} edge='end' size='small'>
                <CloseIcon fontSize='medium' />
              </IconButton>
            </DialogTitle>

            <DialogContent className="notes-modal-body">
              <Box>
                <Typography fontSize='14px' fontWeight="semibold" > Block Reason</Typography>
                <Typography fontWeight='semibold' sx={{ wordBreak: 'break-word' }} fontSize='18px' color='#656575'>{notesData?.blockOnlinePayments?.blockedReason}</Typography>
              </Box>
              <Stack direction='row' justifyContent='space-between' gap={4} alignItems='center' mt={2}>
                <Box>
                  <Typography fontSize='14px' fontWeight="semibold" >Block Date</Typography>
                  <Typography fontWeight='semibold' fontSize='18px' color='#656575'>{notesData?.blockOnlinePayments?.blockedDate ? formatTimestampToDate(notesData?.blockOnlinePayments?.blockedDate) : ''}</Typography>
                </Box>
                <Box>
                  <Typography fontSize='14px' fontWeight="semibold" >Blocked by</Typography>
                  <Typography fontWeight='semibold' fontSize='18px' color='#656575'>{notesData?.blockOnlinePayments?.blockedBy}</Typography>
                </Box>
              </Stack>
            </DialogContent>


          </Dialog>
        </>
      }
    </CommonLayout>
  )
}